@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.DropdownContainer {
  position: relative;
  display: inline-block;

  .listWrapper {
    @extend %font-family-primary;

    // Positioning
    position: absolute;
    z-index: 3;
    display: block;

    ul {
      // Remove bullet points
      width: 247px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      list-style-type: none;
      margin: 0;
      font-size: $font-size-normal;
      color: $theme-color-text;

      li {
        direction: rtl;
        align-items: center;
        gap: 12px;
        align-self: stretch;
        padding: 8px 16px;
        font-weight: 600;
        cursor: pointer;

        &[aria-selected='true'] {
          background: $theme-color-background;
        }

        &:hover {
          background: $theme-color-dropdown-hover-item;
        }

        &.red {
          color: $theme-color-button-delete-danger-color;
        }

        &[aria-disabled='true'] {
          cursor: not-allowed;
          pointer-events: none;
          color: $theme-color-sub-text;
          box-shadow: none;
        }
      }
    }
  }

  &[aria-expanded='true'] ul {
    background: $theme-color-background;
    border-radius: 8px;
    border: 1px solid $theme-color-dropdown-border-color;
    box-shadow: 0 4px 16px 0 $color-dropdown-box-shadow;
    padding: 12px 0;
  }

  &.RightAligned .listWrapper {
    right: 0;
  }
}